import { Vehicle } from '@otw/models/inventory'
import { InventoryV3Row } from './buildInventoryV3Rows'

/** Same match as inventory v2 `opticTruckWorksOnly` in useInventoryFilter. */
export const isOpticOwnedVehicle = (vehicle: Vehicle): boolean =>
  vehicle.who != null && vehicle.who.trim().toLowerCase() === 'optic truck works'

export const rowIsOpticOwned = (row: InventoryV3Row): boolean => isOpticOwnedVehicle(row.vehicle)

/**
 * Same matching as the AG Grid inventory SearchBarUI in useInventoryFilter,
 * plus row-level sold/selling-to display names from Inventory v3.
 */
const rowMatchesTerm = (row: InventoryV3Row, term: string): boolean => {
  if (row.sold_to_name?.toLowerCase().includes(term)) return true
  if (row.selling_to_name?.toLowerCase().includes(term)) return true
  return vehicleMatchesTerm(row.vehicle, term)
}

/**
 * A term hits if it appears in any primitive vehicle field, or in sold_to_user /
 * selling_to_user names. `link` is skipped. Other nested objects are skipped.
 */
const vehicleMatchesTerm = (vehicle: Vehicle, term: string): boolean => {
  if (vehicle.sold_to_user?.name?.toLowerCase().includes(term)) return true
  if (vehicle.selling_to_user?.name?.toLowerCase().includes(term)) return true

  return Object.entries(vehicle).some(([key, value]) => {
    if (key === 'link') return false
    if (value != null && typeof value === 'object') return false
    return value?.toString().toLowerCase().includes(term)
  })
}

/** Split typed or pasted input into individual search terms. */
export const parseSearchTerms = (value: string): string[] =>
  value
    .split(/\n/)
    .map(term => term.trim())
    .filter(Boolean)

/**
 * A row matches if ANY committed term matches (OR), same as v2.
 * An empty list means no search filter.
 */
export const rowMatchesQuickFilter = (row: InventoryV3Row, terms: string[]): boolean => {
  const normalized = terms.map(term => term.toLowerCase().trim()).filter(Boolean)
  if (normalized.length === 0) return true
  return normalized.some(term => rowMatchesTerm(row, term))
}
